import withReportFilterProps from './withReportFilterProps';
export default withReportFilterProps;



// WEBPACK FOOTER //
// ./src/components/withReportFilterProps/index.js